export const PRIORITY_BOARDING_ROUTES = {
  confirmation: "/priority-boarding/confirmation",
  purchase: "/priority-boarding/purchase",
};
